import { render, staticRenderFns } from "./workManage.vue?vue&type=template&id=2afb672b"
import script from "./workManage.vue?vue&type=script&lang=js"
export * from "./workManage.vue?vue&type=script&lang=js"
import style0 from "./workManage.vue?vue&type=style&index=0&id=2afb672b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports